import en from './en.json';
import es from './es.json';

const languages = { en, es };

let defaultLanguage = 'en';

var I18n = (function () {
	const userLang = navigator.language || navigator.userLanguage,
		language = localStorage.getItem('lang') || userLang.substring(0, 2);
	
	let lang = languages[language] || languages.en;
	defaultLanguage = languages[language] ? language : 'en';

	var get = (_module, _key) => {
		if (_module !== undefined) {
			_module = _module.toUpperCase();
			if (_key === undefined) {
				return lang.COMMON?.[_module] || _module;
			} else {
				_key = _key.toUpperCase();
				if (lang[_module]?.[_key] !== undefined) {
					return lang[_module][_key];
				} else {
					return _key;
				}
			}
		}

		return {
			allModule: function (__module) {
				__module = __module.toUpperCase();
				return lang[__module];
			},
		};
	};

	return get;
})();

export default I18n;

export const language = defaultLanguage;
